import { Module } from '@nestjs/common';
import { APP_FILTER, APP_GUARD } from '@nestjs/core';
import { ConfigModule, ConfigService } from '@nestjs/config';
import config from './config/config';
import { MikroOrmModule, MikroOrmModuleOptions } from '@mikro-orm/nestjs';
import { MySqlDriver } from '@mikro-orm/mysql';
import { mikroOrmConfig } from './config/mikro-orm.config';
import { AuthGuard } from './common/guards/auth.guard';
import { HttpExceptionFilter } from './common/filters/http-exception.filter';
// import { UnauthorizedExceptionFilter } from './common/filters/unauthorized-exception.filter';
import { MikroOrmExceptionFilter } from './common/filters/mikro-orm-exception.filter';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { FEATURE_MODULES } from './modules.config';
import { User } from './modules/user/entities/user.entity';
import { ValidatorsModule } from './common/validators/validator.module';
import { UtilsModule } from './shared/utils/utils.module';
import { StorageModule } from './shared/file-upload/storage.module';
import { JwtModule } from '@nestjs/jwt';
import { validate } from './config/env.validation';
import { MulterModule } from '@webundsoehne/nest-fastify-file-upload';

@Module({
  imports: [
    ConfigModule.forRoot({
      isGlobal: true,
      validate,
      load: [config, mikroOrmConfig],
    }),
    JwtModule.registerAsync({
      inject: [ConfigService],
      useFactory: async (configService: ConfigService) => ({
        global: true,
        secret: configService.get<string>('config.jwt.secret'),
        signOptions: {
          expiresIn: configService.get<string>('config.jwt.expirationTime'),
        },
      }),
    }),
    MulterModule.registerAsync({
      inject: [ConfigService],
      useFactory: async (configService: ConfigService) => ({
        dest: configService.get<string>('config.storage.path'),
      }),
    }),
    MikroOrmModule.forRootAsync({
      inject: [ConfigService],
      driver: MySqlDriver,
      useFactory: (configService: ConfigService<Record<string, any>, true>) =>
        configService.get<MikroOrmModuleOptions>('database'),
    }),
    MikroOrmModule.forFeature({ entities: [User] }),
    ValidatorsModule,
    UtilsModule,
    StorageModule,
    ...FEATURE_MODULES,
  ],
  controllers: [AppController],
  providers: [
    AppService,
    {
      provide: APP_GUARD,
      useClass: AuthGuard,
    },
    {
      provide: APP_FILTER,
      useClass: HttpExceptionFilter,
    },
    // {
    //   provide: APP_FILTER,
    //   useClass: UnauthorizedExceptionFilter,
    // },
    {
      provide: APP_FILTER,
      useClass: MikroOrmExceptionFilter,
    },
  ],
})
export class AppModule {}
